import {
  loopbackGet,
  loopbackPost,
} from '..';
import { SurveyHistory, SurveyHistoryDiff, Survey } from '../../redux/types';

/**
 * Get Survey Histories from provided date onwards
 * sorted by {createdAt} descing order
 *
 * @param surveyId survey id
 * @param dateOnwards ISO Date format string get surveys from this date onwards
 */
export const getLatestSurveyHistories = (
  surveyId: number,
  dateOnwards: string,
): Promise<SurveyHistory[]> => {
  const filter = {
    where: {
      and: [
        { surveyId },
        { createdAt: { gt: dateOnwards } },
      ],
    },
    order: [
      'createdAt DESC',
    ],
  };
  const uri = `SurveyHistories?filter=${JSON.stringify(filter)}`;
  return loopbackGet(uri);
};

/**
 * Save Survey payload to Survey History
 * @param data Survey data to save in history
 */
export const saveSurveyHistory = (data: SurveyHistory): Promise<unknown> => {
  const promise = new Promise((resolve, reject) => {
    loopbackPost('SurveyHistories', data).then(resolve, reject);
  });
  return promise;
};

export const getSurveyHistoryDiff = (
  surveyId: number,
  dateOnwards: string,
): Promise<SurveyHistoryDiff> => {
  const uri = `SurveyHistories/getLatestDifference?surveyId=${surveyId}&dateOnwards=${dateOnwards}`;
  return loopbackGet(uri);
};

/**
 * @Admin
 * get survey by trialId
 */
export const getSurveyByTrialId = (trialId: number): Promise<Survey> => {
  const filter = {
    where: {
      trialId,
    },
  };
  const uri = `Surveys/findOne?filter=${JSON.stringify(filter)}`;
  return loopbackGet(uri);
};
